import React from 'react';
import { SelectContainer, Label, StyledSelect, ErrorMessage, HelperText } from './styles';
import { SelectProps } from './types';

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  (
    {
      variant = 'default',
      size = 'default',
      label,
      error,
      helperText,
      items,
      placeholder,
      id,
      className,
      value,
      ...props
    },
    ref
  ) => {
    const selectId = id || `select-${Math.random().toString(36).substr(2, 9)}`;
    const effectiveVariant = error ? 'error' : variant;

    return (
      <SelectContainer className={className}>
        {label && <Label htmlFor={selectId}>{label}</Label>}
        <StyledSelect
          ref={ref}
          id={selectId}
          $variant={effectiveVariant}
          $size={size}
          value={value}
          {...props}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {items.map((item) => (
            <option key={item.value} value={item.value} disabled={item.disabled}>
              {item.label}
            </option>
          ))}
        </StyledSelect>
        {error && <ErrorMessage>{error}</ErrorMessage>}
        {!error && helperText && <HelperText>{helperText}</HelperText>}
      </SelectContainer>
    );
  }
);

Select.displayName = 'Select';

export type { SelectProps, SelectItem, SelectVariant, SelectSize } from './types';
